const urlconfig = require('./config/urlconfig');

export const msalConfig = {
  // auth: {
  //   clientId: "e3de4538-f941-422b-9eae-bba0f4697f34",
  //   authority: "https://login.microsoftonline.com/8075ed4b-7a84-4c5e-a066-370a8effc36b",
  //   redirectUri: urlconfig.frontend,
  // },
  auth: {
//    clientId: "84951dd0-e73d-4dba-af59-d0bf3eda8b6c",
    clientId: "fdff9b73-dad5-40b1-b0e3-ef8396f39b72",
    authority: "https://login.microsoftonline.com/da5284b0-ca6e-4343-ba1a-24725c532d09",
    redirectUri: urlconfig.frontend,
  },
  
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },

  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        // Log all levels for detailed debugging
        switch (level) {
          case 0: console.debug(message); break; // VERBOSE
          case 1: console.info(message); break;  // INFO
          case 2: console.warn(message); break;  // WARNING
          case 3: console.error(message); break; // ERROR
        }
      },
      piiLoggingEnabled: false, // Keep false for now
      logLevel: 0, // Set to 0 for VERBOSE
    }
  }
};

export const loginRequest = {
  scopes: [
    "User.Read",                         // View your own profile
    "User.Read.All",                     // Search other users
    "api://fdff9b73-dad5-40b1-b0e3-ef8396f39b72/access_as_user"  // Access your backend
  ],
};
